import CancelMoveInCostsModalContainer from './container';

export default CancelMoveInCostsModalContainer;
